<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg" style="min-height: 250px">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{$t("ConfirmEmail")}}</h4>
                  <p style="margin-top: 70px" v-if="confirmSuccessful">{{$t("ConfirmEmailText")}}</p>
                  <p style="margin-top: 70px" v-if="confirmFailed">{{$t("ConfirmFailedText")}}</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      confirmSuccessful: false,
      confirmFailed: false
    }
  },
  mounted() {
    this.$vs.loading();
    const thisIns = this;
    this.$http.post('/api/v1/confirmMail/', {
      code: this.$route.params.code
    }).then(function () {
      thisIns.confirmSuccessful = true;
      thisIns.$vs.loading.close();
      setTimeout(function () {
        thisIns.$router.push('/login')
      }, 5000)
    }).catch(function (err) {
      thisIns.$vs.loading.close();
      thisIns.confirmFailed = true;
    });
  }
}
</script>

<style lang="scss">
</style>
